import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../../Messages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {BasePanelPage} from "../../panels/BasePanelPage";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {PANEL_TYPE} from "../../../../../blink-sdk/Constants";


@autoredraw(UserAddressStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardAddressInUsePanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.addressInUseTitle,
        };
    }

    render() {
        const {styleSheet} = this;

        return [
            <div>
                {Messages.addressInUseDashboard}
                <Link onClick={() => Router.changeURL(PANEL_TYPE.dashboard)} value={Messages.here} className={styleSheet.link}/>.
            </div>,
            <MerchantButton label={Messages.ok} className={styleSheet.button} onClick={() => Router.back()}/>
        ];
    }
}
